import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../core/Modal";
import {
  CheckedSupplierSudMonitoringDto,
  ObnalSupplierDto,
} from "../../../services/openapi";
import { ColumnGroupType, ColumnType } from "antd/lib/table";
import { PaginationProps } from "antd";
import CustomTable from "../../core/CustomTable";

type Props = {
  data: CheckedSupplierSudMonitoringDto[];
  isDefaultOpen?: boolean;
};
const CourtMonitoring: React.FC<Props> = ({ data, isDefaultOpen = false }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const onChangePagination: PaginationProps["onChange"] = (pageNumber) => {
    setPage(pageNumber - 1);
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize
  ) => {
    setPage(current);
    setSize(pageSize);
  };

  const columns: (
    | ColumnGroupType<ObnalSupplierDto>
    | ColumnType<ObnalSupplierDto>
  )[] = [
    {
      title: "№",
      key: "id",
      width: "50px",
      className: "text-center gx-0",
      render: (row) => {
        let index = data.indexOf(row);
        return index + 1;
      },
    },
    {
      title: t("registerDate"),
      dataIndex: "reg_date",
      key: "reg_date",
      width: "120px",
    },
    {
      title: t("casenumber"),
      dataIndex: "casenumber",
      key: "casenumber",
      width: "150px",
    },
    {
      title: t("hearingDate"),
      dataIndex: "hearing_date",
      key: "hearing_date",
      width: "120px",
    },
    {
      title: t("claimant"),
      dataIndex: "claimant",
      key: "claimant",
      width: "240px",
    },
    {
      title: t("defendant"),
      dataIndex: "defendant",
      key: "defendant",
      width: "240px",
    },
    {
      title: t("courtResult"),
      dataIndex: "result",
      key: "result",
      width: "220px",
    },
  ];
  return (
    isDefaultOpen ? <CustomTable
          columns={columns}
          data={data}
          page={page}
          pageSize={size}
          loading={false}
          size="small"
          scrollX={1150}
          className="table-striped-rows"
          paginationShowChange={onShowSizeChange}
          paginationChange={onChangePagination}
          totalCount={data.length}
        /> :
    <CustomModal
      title={t("courtMonitoring")}
      hiddenOK={true}
      btnTitle={t("show")}
      width={1400}
      btnClass="btn-sm btn-primary"
      children={
        <CustomTable
          columns={columns}
          data={data}
          page={page}
          pageSize={size}
          loading={false}
          size="small"
          scrollX={1150}
          className="table-striped-rows"
          paginationShowChange={onShowSizeChange}
          paginationChange={onChangePagination}
          totalCount={data.length}
        />
      }
    />
  );
};

export default CourtMonitoring;
